import React from 'react';
import PropTypes from 'prop-types';

export default function Footer({ row, children }) {
  return (
    <footer
      className={`prints-builder__footer d-flex align-items-center ${row ? 'flex-row justify-content-around' : 'flex-column'}`}>
      {children}
    </footer>
  );
}

Footer.propTypes = {
  row: PropTypes.bool,
};
